/**
 * The previous portal page in this tab, for the locked screen's "Go back".
 *
 * The router's own history index says "there is a page behind this one" only
 * for client-side navigations. A seller who opened a locked address directly
 * (typed, bookmarked, a full reload) has index 0 even though the portal page
 * they were just on is one step behind — and "Go back" used to drop them on
 * the dashboard instead. So the boundary records each portal path as it is
 * shown, per tab (sessionStorage), and the locked screen returns to the one
 * before the current path. Storage can be unavailable (private mode, blocked
 * site data); everything here then quietly falls back to "no previous page".
 */
const CURRENT = "seller.portalPath.current";
const PREVIOUS = "seller.portalPath.previous";

function read(key: string): string | null {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}
function write(key: string, value: string) {
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    /* storage unavailable: no previous page is recorded */
  }
}

/** Record that `path` (pathname + search) is now on screen. */
export function notePortalPath(path: string) {
  const current = read(CURRENT);
  if (current === path) return;
  if (current) write(PREVIOUS, current);
  write(CURRENT, path);
}

/** The portal page shown before `path` in this tab, if any. */
export function previousPortalPath(path: string): string | null {
  const current = read(CURRENT);
  const previous = current === path ? read(PREVIOUS) : current;
  return previous && previous !== path ? previous : null;
}
